import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class PanelSubNav extends PureComponent {
  static propTypes = {
    activeSubNav: PropTypes.string,
    className: PropTypes.string,
    subNavs: PropTypes.array
  };

  static defaultProps = {
    activeSubNav: null,
    className: "",
    subNavs: []
  };

  render() {
    return (
      <div className={classNames("panel-subnav", this.props.className)}>
        {this.props.subNavs.map(subNav => (
          <button
            key={subNav.key}
            onClick={() => subNav.onClick(subNav.key)}
            className={classNames("panel-subnav__item", subNav.className, this.props.activeSubNav === subNav.key && "--active")}>
            {subNav.label}
          </button>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelSubNav.js